import React, { Component } from "react";
import Client from "../Client";
import BlackLoading from "../images/black-loader.gif";
import marked from "marked"; //to make font bold and headings
import {Link} from 'react-router-dom';

class PremierGardenCare extends Component {
  constructor(props) {
    super(props);
    this.state = {
      premiergardencarepage: [],
    };
  }

  componentDidMount() {
    Client.getEntries({
      content_type: "premiergardencareNew",
    }).then((entries) => {
      this.setState({ premiergardencarepage: entries.items });
    });
  }

  //to make font bold and headings
  getParsedMarkdown(premiergardencareDescription) {
    return {
      __html: marked(premiergardencareDescription, { sanitize: false }),
    };
  }
  //to make font bold and headings - end

  render() {
    return (
      <>
      <div className="container-fluid">
        {this.state.premiergardencarepage.length === 0 ? (
          <div align="center">
            <img src={BlackLoading} alt="Loading..." />
          </div>
        ) : (
          <div className="row">
            {this.state.premiergardencarepage.map((item, index) => {
              return (
                <div key={index} className="col-lg-12">
                  <div className="text-left pt-2">
                    <h1 className="text-uppercase">{item.fields.premiergardencareTitle}</h1>
                    <h2 className="lead">{item.fields.premiergardencareShortDetails}</h2>
                  </div>

                  <div className="pt-2">
                    <div className="row">
                      <div className="col-lg-4">
                        <img
                          className="img-fluid"
                          src={item.fields.premiergardencareImg.fields.file.url}
                          alt="premier garden care"
                        />
                        
                      </div>
                      <div className="col-lg-8">
                        {/* <p>{item.fields.aboutDescription}</p> */}
                        <div dangerouslySetInnerHTML = {this.getParsedMarkdown(
                            item.fields.premiergardencareDescription
                        )}></div>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        )}

      <div className="pt-4">
      <Link to="/premier-garden-care-gallery"><button className="btn btn-primary">Click to view more</button></Link>
      </div>
      </div>

      </>
    );
  }
}

export default PremierGardenCare;
